import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

const RANKING_DEPARTURE_UNJUSTIFIED = "zz_SourcingEventApiErrorCode_RankingDepartureJustificationMissing";

export const isRankingDepartureRefusal = (e: unknown): boolean =>
  e != null && isFetchBaseQueryError(e) && isApiErrorDto(e.data) && e.data.errorCode === RANKING_DEPARTURE_UNJUSTIFIED;
